import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Arabic_Landing from "./arabic landing/landing/Arabic_Landing";
import Landing from "./landing/Landing";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Arabic_Landing />}></Route>
          <Route path="/landing" element={<Landing />}></Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
